import { applyPolyfills, defineCustomElements } from "@product/scmp-menu-component/loader";
import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { useEffect, useRef, useState } from "react";
import { Transition } from "react-transition-group";

import { hamburgerMenuAtom } from "./atoms";
import { HamburgerMenuContent } from "./hamburger-menu-content";

export const HamburgerMenu: FunctionComponent = () => {
  const [isCustomElementsInitialized, setIsCustomElementsInitialized] = useState(false);
  const hamburgerMenu = useAtomValue(hamburgerMenuAtom);
  const isHamburgerMenuOpen = hamburgerMenu.isOpen;

  useEffect(() => {
    void applyPolyfills().then(() => {
      void defineCustomElements().then(() => {
        setIsCustomElementsInitialized(true);
      });
    });
  }, []);

  const nodeReference = useRef(null);

  return isCustomElementsInitialized ? (
    <Transition in={isHamburgerMenuOpen} nodeRef={nodeReference} timeout={200} mountOnEnter>
      {state => <HamburgerMenuContent ref={nodeReference} state={state} />}
    </Transition>
  ) : null;
};

HamburgerMenu.displayName = "HamburgerMenu";
